import { frontendURL } from '../../../helper/URLHelper';

const KanbanView = () => import('./KanbanView.vue');

export const routes = [
  {
    path: frontendURL('accounts/:accountId/kanban'),
    name: 'kanban_board',
    meta: {
      permissions: [
        'administrator',
        'agent',
        'control',
        'coordination',
        'monitoring',
      ],
    },
    component: KanbanView,
  },
];
